import React, { useEffect, useState, useLayoutEffect, useRef, Fragment } from 'react';
import PubSub from 'pubsub-js';
import { useStyle } from './PrequalStyle.js';
import { Grid, Typography, Button, TextField, Popper } from '@material-ui/core';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { useApolloClient } from '@apollo/client';
import { getAddressList } from './EirPrequalIntegration.js';
import { useLocalStorage } from './EirPrequalPersistance';
import {
    VALIDATION_TEXT,
    USE_EIRCODE_TEXT,
    checkAvailabilityText,
    EIRCODE_TEXTFIELD_ICON_IMAGE,
} from './Constants.js';
import { getContext, formatAddress, validateEircode } from './EirPrequalUtil';

export default function EirPrequalEircode(props) {
    const [open, setOpen] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [isEirCodeValid, setIsEirCodeValid] = useState(true);
    const [isEircodeEmpty, setEircodeEmpty] = useState(false);
    const [fontColor, setFontColor] = useState('');
    const [disableButton, setDisableButton] = useState(true);
    const [eirCode, setEirCode] = useState('');
    const [fieldvalue, isEircodeFieldEmpty] = useState(true);
    const [prequalAddressObject, setPrequalAddressObject] = useState({});
    const { getLocalStorage, setLocalStorage } = useLocalStorage();

    const eircodeInputRef = useRef(null);

    const eirPrequalFlag = 'eircode';
    const graphql = useApolloClient();
    const classes = useStyle();
    const context = getContext();

    useEffect(() => {
        if (!fontColor) setFontColor(props.prop.resources.textFontColor);
        let obj = getLocalStorage('eir_prequal_data');
        if (obj) {
            createAddressObject(obj);
        }
    }, []);
    useEffect(() => {
        PubSub.subscribe('SCROLL_TOP', () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
            if (fieldvalue === true) {
                eircodeInputRef.current.focus();
                setEircodeEmpty(true);
            } else {
                setEircodeEmpty(false);
            }
        });
    }, []);
    useLayoutEffect(() => {
        let obj = getLocalStorage('eir_prequal_data');
        if (obj && document.getElementById('eircode').value === '') {
            if (obj.selectedAddress) {
                document.getElementById('eircode').value = obj.selectedAddress;
                setDisableButton(false);
            }
        }
    });
    useEffect(() => {
        //getting the context from the url
        let currentContext = window.location.pathname.slice(1);
        let queryString = window.location.search.substring(1) !== '' && `?${window.location.search.substring(1)}` || '' ;
        //when first time pages other than broadband or tv loads
        if (!getLocalStorage('currentContext')) {
            setLocalStorage('currentContext', currentContext);
        }

        else if (window.location.pathname.includes(getLocalStorage('currentContext')) === false)
            setLocalStorage('currentContext', currentContext);

        //when page comed back from /results it will get the context from localstorage and set the virtual url
        if (getLocalStorage('currentContext')) {
            let cont = getLocalStorage('currentContext');
           window.history.pushState({}, '', window.location.origin + `/${cont}`  + queryString);
        }
    }, []);
    const CustomPopper = function (props) {
        return <Popper {...props} className={classes.AutocompleteListItems} placement='bottom' />;
    };

    //function to return dummy object to append for address not found
    function getDefaultAddressValue(propValue) {
        return [
            {
                addressLine1: `${USE_EIRCODE_TEXT.text}`,
                addressLine2: `${USE_EIRCODE_TEXT.urlText}`,
                addressLine3: '',
                county: '',
                eircode: propValue,
                town: '',
                switchtoPhone: true,
                userEnteredEirCode: propValue,
            },
        ];
    }
    const cantFindAddressText = (
        <div className={classes.AutocompleteNotFound}>
            {
                isEirCodeValid ? <Fragment> {USE_EIRCODE_TEXT.text}{' '}</Fragment> : <Fragment>
                    {USE_EIRCODE_TEXT.text}{' '}
                    <span className='AutocompleteNotFound-highlighted'>{USE_EIRCODE_TEXT.urlText}</span>
                </Fragment>
            }
        </div>
    );

    const setAddressList = async function (eirCode) {
        let validEircode;
        let tempDefaultValue = getDefaultAddressValue(eirCode); //get the dummy object
        if (eirCode && eirCode.length >= 7) {
            validEircode = validateEircode(eirCode);
            if (validEircode.length > 0) {
                setEirCode(validEircode);
                setIsEirCodeValid(true);
                try {
                    let data = await getAddressList(graphql, validEircode);
                    let fullList = [...data.addressList.addresses, ...tempDefaultValue].map(
                        val => ({
                            ...val,
                            userEnteredEirCode: eirCode, // append user entered input as a property to all the objects in the data fetched from API
                        })
                    ); //append dummy object to data fetched from API
                    setAddresses(fullList);
                    setOpen(true);
                } catch (err) {
                    // setAddressFound(false);
                    setAddresses([...tempDefaultValue]); // show cant find address when API fails
                }
            } else if (eirCode.length >= 7 && validEircode.length === 0) {
                setIsEirCodeValid(false);
              //  setAddresses([...tempDefaultValue]); // show cant find address when eircode length is >=7

                // setAddressFound(false);
            }
        } else {
            setOpen(false);
            setDisableButton(true);
           // setAddresses([...tempDefaultValue]); // show cant find address when eircode length is less than 7
            // setAddressFound(false);
        }
    };
    const handleEircodeChange = value => {
        isEircodeFieldEmpty(true);
        if (!value || value.length < 7) {
            setOpen(false);
            setIsEirCodeValid(true);
            setDisableButton(true);
        }
        if (value.length > 0) {
            isEircodeFieldEmpty(false);
            setEircodeEmpty(false);
        }
        setAddressList(value);
    };
    const filterOptions = createFilterOptions({
        stringify: option => option.userEnteredEirCode, // filter based on eircode entered by user, was earlier filtering by eircode returned from API
    });
    //method for fomatting the selected address, into a particualar object
    const createAddressObject = address => {
        let obj;
        obj = {
            eircode: eirCode ? eirCode : address.eircode,
        };
        if (address.county) {
            let county = address.county.replace('CO_', '');

            obj = { ...obj, ...{ county: county } };
        } else obj = { ...obj, ...{ county: '' } };

        if (address.town) obj = { ...obj, ...{ town: address.town } };
        else obj = { ...obj, ...{ town: '' } };

        if (address.addressLine1) obj = { ...obj, ...{ addressLine1: address.addressLine1 } };
        else obj = { ...obj, ...{ addressLine1: '' } };

        if (address.addressLine2) obj = { ...obj, ...{ addressLine2: address.addressLine2 } };
        else obj = { ...obj, ...{ addressLine2: '' } };

        if (address.addressLine3) obj = { ...obj, ...{ addressLine3: address.addressLine3 } };
        else obj = { ...obj, ...{ addressLine3: '' } };

        setPrequalAddressObject({
            ...obj,
        });
    };

    //check availability submit function
    const checkAvailability = () => {
        let obj = {
            ...prequalAddressObject,
            ...{ selectedAddress: document.getElementById('eircode').value },
        };
        setLocalStorage('ls_district', prequalAddressObject.town);
        setLocalStorage('ls_county', prequalAddressObject.county);
        props.prop.submitHandler(graphql, obj, eirPrequalFlag, 'Eircode');
    };

    return (
        <div>
            <Grid className={classes.CTAInputContainer}>
                <div className={classes.CTAInputBox}>
                    <Autocomplete
                        id='eircode'
                        className={classes.AutocompleteTextField}
                        loadingText='Loading..'
                        debug
                        forcePopupIcon={false}
                        autoComplete={true}
                        options={addresses}
                        open={open}
                        classes={{
                        noOptions: classes.noOptions
                        }}
                        noOptionsText='Please enter a valid Eircode.'//'No Addresses Found, Try using Landline Number
                        PopperComponent={CustomPopper}
                        onChange={(event, value) => {
                            if (value.switchtoPhone != undefined && value.switchtoPhone == true) {
                                isEircodeFieldEmpty(false);
                                //if user clicks on can't find address
                                setDisableButton(true);
                                props.makePhoneNumberVisible();
                            } else {
                                setOpen(false); // to close dropdown when user selects a address from dropdown
                                setDisableButton(false);
                                createAddressObject(value);
                                setOpen(false);
                            }
                        }}
                        getOptionLabel={option => {
                            return formatAddress(option);
                        }}
                        renderOption={option => {
                            if (option.switchtoPhone != undefined && option.switchtoPhone == true) {
                                // render can't find address text
                                return cantFindAddressText;
                            } else {
                                setEircodeEmpty(false);
                                // render address fetched from API with proper formatting
                                return formatAddress(option);
                            }
                        }}
                        filterOptions={filterOptions}
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant='outlined'
                                placeholder='Enter your Eircode'
                                className={
                                    isEircodeEmpty ? classes.CTAInputEmpty : classes.CTAInput
                                }
                                // inputRef={isEircodeEmpty ? input => input && input.focus() : ''}
                                inputRef={eircodeInputRef}
                                error={!isEirCodeValid}
                                onChange={e => {
                                    handleEircodeChange(e.target.value);
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                        <img
                                            src={EIRCODE_TEXTFIELD_ICON_IMAGE}
                                            className={classes.TextFieldIconImage}
                                        />
                                    ),
                                    endAdornment: null,
                                }}
                            />
                        )}></Autocomplete>
                    {!isEirCodeValid && (
                        <Typography
                            className={classes.EircodeValidity}
                            style={{ color: fontColor }}>
                            {VALIDATION_TEXT.eircodeValidation}
                        </Typography>
                    )}
                    {isEircodeEmpty && (
                        <Typography
                            className={classes.EircodeValidity}
                            style={{ color: fontColor }}>
                            {VALIDATION_TEXT.eircodeRequired}
                        </Typography>
                    )}
                </div>
                <Button
                    id='check_via_eircode'
                    disableRipple={true}
                    className={
                        classes.CTAButton + ' ' + (!isEirCodeValid && classes.CTAButtonExtraMargin)
                    }
                    disabled={disableButton}
                    onClick={() => {
                        checkAvailability();
                    }}>
                    {checkAvailabilityText}
                </Button>
            </Grid>
        </div>
    );
}
